import store from '@/store';

const $_twitch = window.Twitch.ext;

export const TwitchService = {
    setConfigurationPanelView() {
        $_twitch.configuration.onChanged(() => {
            const broadcaster = $_twitch.configuration.broadcaster;
            const broadcasterContent = broadcaster ? JSON.parse(broadcaster.content) : null;
            const { configuredVoices, configuration } = broadcasterContent;

            store.dispatch('twitchSettings/axn_initSettings', broadcasterContent);
            store.dispatch('panel/axn_loadPanelConfiguredVoices', configuredVoices);
            store.dispatch('panel/axn_panelMinimumTime', parseInt(configuration.minimumTimeSeconds));
        });
    },

    listenConfiguration() {
        $_twitch.listen('broadcast', (target, contentType, message) => {
            // TODO: double-check if message if an obj
            // TODO: and check the obj has the correct properties
            const { configuredVoices, configuration } = message ? JSON.parse(message) : null;

            store.dispatch('twitchSettings/axn_initSettings', message);
            store.dispatch('panel/axn_loadPanelConfiguredVoices', configuredVoices);
            store.dispatch('panel/axn_panelMinimumTime', parseInt(configuration.minimumTimeSeconds));
        });
    },

    viewerOnChanged() {
        $_twitch.viewer.onChanged(() => {
            store.dispatch('global/axn_viewerIsLinked', $_twitch.viewer.isLinked);
            store.dispatch('global/axn_viewerSubscriptionStatus', $_twitch.viewer.subscriptionStatus);
        });
    },

};

export default TwitchService;
